export const Validate = {
    //判断是否为空
    isEmpty: function (string) {
        if (string === '') {
            return 1;
        }
        return 0;
    },
    isMobile: function (mobile) {
        if (/^(13|14|15|17|18)[0-9]{9}$/.test(mobile)) {
            return 1;
        }
        return 0;
    },
    isEmail: function (email) {
        var re = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        if (re.test(email)) {
            return 1;
        }
        return 0;
    },
    pwdLevel: function (password) {
        var Modes = 0,
            i;
        var type = []; //存类型
        function CharMode(iN) {
            //数字
            if (iN >= 48 && iN <= 57) {
                if (type.indexOf('d') < 0) {
                    type.push('d');
                }
                return 1;
            }
            //大小写字母
            if ((iN >= 97 && iN <= 122) || (iN >= 65 && iN <= 90)) {
                if (type.indexOf('w') < 0) {
                    type.push('w');
                }
                return 4;
            } else { //特殊字符
                if (type.indexOf('o') < 0) {
                    type.push('o');
                }
                return 8;
            }
        }
        for (i = 0; i < password.length; i++) {
            CharMode(password.charCodeAt(i));
        }
        return type;
    }
};

export const mailMap = {
    'qq.com': 'http://mail.qq.com',
    'gmail.com': 'http://mail.google.com',
    'sina.com': 'http://mail.sina.com.cn',
    '163.com': 'http://mail.163.com',
    '126.com': 'http://mail.126.com',
    'yeah.net': 'http://www.yeah.net/',
    'sohu.com': 'http://mail.sohu.com/',
    'tom.com': 'http://mail.tom.com/',
    'sogou.com': 'http://mail.sogou.com/',
    '139.com': 'http://mail.10086.cn/',
    'hotmail.com': 'http://www.hotmail.com',
    'live.com': 'http://login.live.com/',
    'live.cn': 'http://login.live.cn/',
    'live.com.cn': 'http://login.live.com.cn',
    '189.com': 'http://webmail16.189.cn/webmail/',
    'yahoo.com.cn': 'http://mail.cn.yahoo.com/',
    'yahoo.cn': 'http://mail.cn.yahoo.com/',
    'eyou.com': 'http://www.eyou.com/',
    '21cn.com': 'http://mail.21cn.com/',
    '188.com': 'http://www.188.com/',
    'foxmail.coom': 'http://www.foxmail.com'
};


export const renderHtml = ['<dl class="clear"><dt>新 密 码</dt><dd class="long pwd-new-wrap"><input type="password" class="input tel" placeholder="8-16位字符(需包含大写字母、小写字母、数字以及特殊字符中的三种)" node-type="passport-pass1">' +
    // '<div class="safe-tip"><span>安全强度：</span><i class="low ">低</i><i class="mid ">中</i><i class="high ">高</i></div>' +
    '</dd></dl><dl class="clear"><dt>确认密码 </dt><dd class="pwd-cfm-wrap long">' +
    '<input type="password" class="input validate" name="validate" id="validate" placeholder="请再次输入密码" node-type="passport-pass2"></dd></dl><dl class="clear"><dt></dt>' +
    '<dd class="submit"><a class="submit-btn disabled" href="javascript:void(0)" next-step="13" node-type="mobile-step2">确定</a></dd></dl>',
    '<p class="tip mail-sended">验证邮件已发送</p><p class="tip-small">验证邮件已发送至您的邮箱<b class="sended-mail"></b>，点击邮件中的链接完成操作，验证邮件<b>24个小时</b>内有效，请尽快验证！</p>' +
    '<div class="btn-wrap"><a class="submit-btn goto-mail-btn" href="javascript:void(0)">立即前往验证</a> <span class="send-msg-wrap"></span></div>',
    '<p class="tip">密码设置成功</p>', ' <p class="tip tip-err">链接已失效</p><p class="tip-time-out send-msg-wrap">验证链接已失效，点击 <a class="resend" href="#">重新发送</a>'
    ]



// WEBPACK FOOTER //
// ./src/module/passport-password/helper.js